export const INSTRUCTOR_TBD = 'Instructor TBD';

const nameOrNull = (value) =>
    typeof value === 'string' && value.trim() ? value.trim() : null;

/**
 * Who teaches the section a course support application asks for. The catalog
 * course is the umbrella for every section, so only the request for a CRN
 * knows: the instructor of record when it was filed on someone's behalf (the
 * linked account's name, else the name typed on the form), otherwise the
 * applicant. `viewer` is the signed-in user's profile; it names the applicant
 * when the API sent the applicant as an id only. Always a name, never an
 * address or a 900 number. Null when the request does not say.
 */
export function requestInstructorName(application, viewer) {
    if (!application) return null;
    if (application.isSubmittedOnBehalf) {
        return (
            nameOrNull(application.instructorOfRecord?.name) ||
            nameOrNull(application.courseConfirmation?.instructorOfRecordName)
        );
    }
    const applicant = application.applicant;
    const applicantName = nameOrNull(applicant?.name);
    if (applicantName) return applicantName;
    const applicantId = String(applicant?._id ?? applicant ?? '');
    if (viewer?._id && applicantId === String(viewer._id)) {
        return nameOrNull(viewer.name);
    }
    return null;
}

export function requestInstructorLabel(application, viewer) {
    return requestInstructorName(application, viewer) || INSTRUCTOR_TBD;
}
